import { render } from "./AbsoluteMenu.vue?vue&type=template&id=9032a2a0&ts=true"
import script from "./AbsoluteMenu.vue?vue&type=script&lang=ts"
export * from "./AbsoluteMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__